import { useMemo } from 'react';
import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios';

import { useUrl } from 'widget/hooks';

const useWhatcrmApi = () => {
  const { WHATCRM_API } = useUrl();

  const instance = useMemo(
    () =>
      axios.create({
        baseURL: WHATCRM_API,
        headers: {
          'Content-Type': 'application/json',
          'X-Whappim-Token': process.env.REACT_APP_WHATCRM_TOKEN,
        },
      }),
    [],
  );

  const handleThen = <T>(response: AxiosResponse<T>): T | null => {
    if (!response.data) return null;
    if (typeof response.data != 'object') return null;
    if ('error_code' in response.data) return null;
    if ('error_text' in response.data) return null;
    if ('error' in response.data) return null;

    return response.data;
  };

  const request = async <T>(
    url: string,
    config: AxiosRequestConfig,
  ): Promise<T | null> => {
    const data = await instance(url, config)
      .then(handleThen)
      .catch(() => null);

    return data;
  };

  interface PostManagersCallbackData {
    caller_id_name: string;
    chat_key: string | null;
    dst_ani: string | undefined;
    dst_num: string;
    extension_id: number;
    src_num: string;
    user_id: string | null;
    userId: string | null; // deprecated
  }

  const postManagersCallback = (
    client_id: string,
    data: PostManagersCallbackData,
  ) =>
    request('v3/managers/callback', {
      data: { ...data, timestamp: Math.floor(Date.now() / 1000) },
      method: 'post',
      params: { client_id },
    });

  return { postManagersCallback };
};

export default useWhatcrmApi;
